// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2682":"30c2a5a2","7121":"30c2a5a2","7862":"30c2a5a2","8288":"30c2a5a2","8435":"30c2a5a2"}[chunkId] + ".chunk.css";
};